<div appTheme>
    <div *ngIf="hasAlerts" class="alerts-container row">
        <div class="row">
            <div class="alerts-name">
                <div class="alert-banner-text">{{ alertBannerText }}</div>
                <span class="alerts-close-button" [hidden]="isCriticalAlert" (click)="closeAlerts()"> X </span>
                <span class="alerts-more">
                        <!--TODO: use this link <a *ngIf="alerts && alerts.length > 1" [hidden]="isCriticalAlert" (click)="toggleAlertsList()">+{{alerts.length-1}} more</a>-->
                        <a (click)="toggleAlertsList()">+5 more</a>
                </span>
            </div>
        </div>
    </div>
    <div *ngIf="showAlertsList" class="modal-box" (click)="toggleAlertsList()">
        <div class="modal-box-container main-container" (click)="eatClick($event)">
            <h1>Alerts</h1>
            <div class="scrolling">
                <div class="row alerts-list">
                    <ul>
                        <li *ngFor="let alert of alerts" class="alerts-list-item">{{alert.alertDefinition}}</li>
                        <li class="alerts-list-item">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                            specimen book
                        </li>
                        <li class="alerts-list-item">It has survived not only five centuries, but also the leap into electronic typesetting, remaining
                            essentially unchanged.
                        </li>
                        <li class="alerts-list-item">It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and
                            more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </li>
                        <li class="alerts-list-item">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical
                            Latin literature from 45 BC, making it over 2000 years old.
                        </li>
                        <li class="alerts-list-item">Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more
                            obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature,
                            discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The
                            Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
                            Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32./li>
                    </ul>
                </div>
            </div>
            <br>
            <button class="submit-button" id="closeBtn" (click)="toggleAlertsList()">Close</button>
        </div>
    </div>
</div>
